import { Pipe, PipeTransform } from '@angular/core';
import { NO_VALUE } from '@pipes';

@Pipe({
  name: 'absoluteValue',
  standalone: true,
})
export class AbsoluteValuePipe implements PipeTransform {
  transform(value: string): string {
    if (!value || value === NO_VALUE) {
      return NO_VALUE;
    }

    const absoluteValue = value.replaceAll('-', '');

    return absoluteValue;
  }
}
